export default "__VITE_ASSET__D3$WVO7n__"